import { useWindowSize } from '../hooks/useWindowResize';

export const IsMobileCustom = () => {
  const size = useWindowSize();
  return size.width <= 540;
};
